import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TagManager from "react-gtm-module";
import "./PaymentSuccess.css";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const OrderId = new URLSearchParams(location.search).get("order_number");
  const [countdown, setCountdown] = useState(5);

  const handleContinue = () => {
    navigate(`/customer/rentdealsdetails?OrderId=${OrderId}`);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(`/customer/rentdealsdetails?OrderId=${OrderId}`);
    }, 5000);

    // Countdown interval
    const countdownInterval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // GTM: booking_complete — fires once on payment success page load
    TagManager.dataLayer({
      dataLayer: {
        event: "booking_complete",
        page_type: "payment_success",
        page_path: window.location.pathname,
        page_url: window.location.href,
        order_id: OrderId,
        currency: "AED",
      }
    });

    return () => {
      clearTimeout(timer);
      clearInterval(countdownInterval);
    };
  }, [navigate, OrderId]);

  return (
    <div className="payment-success-overlay">
      <div className="payment-success-container">
        {/* Glowing Checkmark Icon with Particles */}
        <div className="payment-checkmark-container">
          {/* Outer glow rings */}
          <div className="payment-glow-ring payment-glow-ring-1"></div>
          <div className="payment-glow-ring payment-glow-ring-2"></div>
          <div className="payment-glow-ring payment-glow-ring-3"></div>

          {/* Particle effects */}
          <div className="payment-particle payment-particle-1">✦</div>
          <div className="payment-particle payment-particle-2">✦</div>
          <div className="payment-particle payment-particle-3">✦</div>
          <div className="payment-particle payment-particle-4">✦</div>
          <div className="payment-particle payment-particle-5">✦</div>
          <div className="payment-particle payment-particle-6">✦</div>

          {/* Main checkmark circle */}
          <div className="payment-checkmark-circle">
            <svg
              className="payment-checkmark-icon"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 13l4 4L19 7"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h2 className="payment-modal-title">Payment Success! 🎉</h2>

        {/* Order ID */}
        <p className="payment-order-id">Order ID: {OrderId}</p>

        {/* Description */}
        <p className="payment-modal-description">
          We have received your booking and payment. Booking confirmation will be sent on email.
        </p>

        {/* Action Button */}
        <button className="payment-continue-button" onClick={handleContinue}>
          Continue to Order Details
        </button>

        {/* Auto-redirect message */}
        <p className="payment-redirect-message">
          Redirecting automatically in {countdown} second{countdown !== 1 ? 's' : ''}...
        </p>
      </div>
    </div>
  );
};

export default PaymentSuccess;
